import React from 'react';
import { Box, keyframes, Typography, useMediaQuery } from '@mui/material';
import {
  AI_AGENT_THINKING_HINT,
  AI_AGENT_THINKING_LABEL,
  AI_AGENT_TOKENS,
} from '../AIAgentConstants';

const dotPulse = keyframes`
  0%, 80%, 100% { opacity: 0.35; transform: scale(0.85); }
  40% { opacity: 1; transform: scale(1); }
`;

export default function AIAgentThinkingIndicator() {
  const prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label={AI_AGENT_THINKING_LABEL}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 0.5,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        {!prefersReducedMotion && (
          <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }} aria-hidden="true">
            {[0, 1, 2].map((index) => (
              <Box
                key={index}
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: '3.5px',
                  backgroundColor: AI_AGENT_TOKENS.primary,
                  animation: `${dotPulse} 1.2s infinite`,
                  animationDelay: `${index * 0.2}s`,
                }}
              />
            ))}
          </Box>
        )}
        <Typography
          sx={{
            fontFamily: AI_AGENT_TOKENS.fontFamily,
            fontWeight: 600,
            fontSize: 14,
            lineHeight: '18.75px',
            color: AI_AGENT_TOKENS.textBody,
          }}
        >
          {AI_AGENT_THINKING_LABEL}
        </Typography>
      </Box>
      <Typography
        sx={{
          fontFamily: AI_AGENT_TOKENS.fontFamily,
          fontWeight: 400,
          fontSize: 12,
          lineHeight: '16.5px',
          color: AI_AGENT_TOKENS.textDisabled,
        }}
      >
        {AI_AGENT_THINKING_HINT}
      </Typography>
    </Box>
  );
}
